import { HappyHourDiscountType } from '@client/graphql/types/graphql';
import { useFocusedCompanyContext } from '@packages/core/company/focused-company-context';
import CurrencyView from '@packages/core/utils/currency-view';

export default function DiscountView(data: { discountAmount: number; discountType: HappyHourDiscountType }) {
  const company = useFocusedCompanyContext();
  return (
    <>
      {data.discountType == HappyHourDiscountType.Amount && (
        <CurrencyView price={data.discountAmount} currency={company.settings.currency} />
      )}

      {data.discountType == HappyHourDiscountType.Percentage && (
        <span>{data.discountAmount}%</span>
      )}
    </>
  );
}
